import angular from 'angular';
import uiRouter from 'angular-ui-router';
import clientComponent from './client.component';

let clientModule = angular.module('client', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newClient', {
            url: '/clients/new',
            component: 'client',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editClient', {
            url: '/clients/:id',
            component: 'client',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                client: (ClientsService, $stateParams) => {
                    return ClientsService.findById($stateParams.id, {
                        include: [
                            'createdByUser',
                            'updatedByUser'
                        ]
                    });
                }
            }
        });
})
.component('client', clientComponent)
.name;

export default clientModule;

















